<template>
  <BaseLanding
    :faq-id="15">
    <template #header>
      <div>{{$t('renew_header_moto')}}</div>
    </template>
  </BaseLanding>
</template>

<script>
import BaseLanding from '@/components/BaseLanding.vue'

export default {
  name: 'LandingMotorcycle',
  components: {
    BaseLanding
  }
}
</script>
